import { Stack, Typography } from '@mui/material';
import MultiDocumentAgentCreateButton from '@features/admin-multi-document-agent/components/CreateButton';

function MultiDocumentAgentTableToolbar() {
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={2}
      justifyContent="space-between"
      alignItems="center"
    >
      <Typography variant="h3">List of Multi-document Agents</Typography>
      <MultiDocumentAgentCreateButton />
    </Stack>
  );
}

export default MultiDocumentAgentTableToolbar;
